import { render, staticRenderFns } from "./ClinicPricing.vue?vue&type=template&id=3480f558&"
import script from "./ClinicPricing.vue?vue&type=script&lang=js&"
export * from "./ClinicPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports